import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "allocated", "remaining", "overError", "underError"];

  connect() {
    this.form = this.element.closest("form");
    this.boundPreventSubmit = this.preventSubmit.bind(this);
    this.form?.addEventListener("submit", this.boundPreventSubmit);
  }

  disconnect() {
    this.form?.removeEventListener("submit", this.boundPreventSubmit);
  }

  divideEvenly() {
    const count = this.inputTargets.length;
    if (count === 0) return;

    const share = Math.floor((100 / count) * 100) / 100;
    const remainder = Math.round((100 - share * count) * 100) / 100;

    this.inputTargets.forEach((input, index) => {
      input.value = index === 0 ? (share + remainder).toFixed(2) : share.toFixed(2);
      input.setCustomValidity("");
      const wrapper = input.closest("[data-controller='field-validation']");
      if (wrapper) {
        wrapper.classList.remove("field-error");
        const errorMsg = wrapper.querySelector("[data-field-validation-target='errorMessage']");
        if (errorMsg) errorMsg.textContent = "";
      }
    });

    this.updateTotals();
  }

  updateTotals() {
    const allocated = this.inputTargets.reduce((sum, input) => {
      return sum + (parseFloat(input.value) || 0);
    }, 0);

    const allocatedRounded = Math.round(allocated * 100) / 100;
    const remaining = Math.round((100 - allocatedRounded) * 100) / 100;

    this.allocatedTarget.textContent = `${allocatedRounded}%`;
    this.remainingTarget.textContent = `${Math.max(remaining, 0)}%`;
    this.overErrorTarget.classList.toggle("hidden", allocatedRounded <= 100);
    this.underErrorTarget.classList.add("hidden");
  }

  preventSubmit(event) {
    const fieldValue = event.submitter?.closest("[data-button-field-value-value]")?.dataset?.buttonFieldValueValue ?? "";
    if (fieldValue.includes("back")) return;

    const allocated = this.inputTargets.reduce((sum, input) => {
      return sum + (parseFloat(input.value) || 0);
    }, 0);

    const allocatedRounded = Math.round(allocated * 100) / 100;

    if (allocatedRounded > 100) {
      this.overErrorTarget.classList.remove("hidden");
      event.preventDefault();
      event.stopPropagation();
    } else if (allocatedRounded < 100) {
      this.underErrorTarget.classList.remove("hidden");
      event.preventDefault();
      event.stopPropagation();
    }
  }
}
